import React, { useState, useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
// import Paper from '@material-ui/core/Paper';
import SingleSelect from '../dropdown/SingleSelect.component';
import Checkbox from '@material-ui/core/Checkbox';

import OptimizationThreshold from "./OptimizationThreshold/OptimizationThreshold"
import { ReportContext } from "../../../layout/Content/MainContent.component";
import { ReactComponent as CheckBoxCheckedIcon } from "../../../assets/svg/checkbox_checked.svg";
// import { ReactComponent as CheckBoxIcon } from "../../../assets/svg/checkbox.svg";
import ClipLoader from "react-spinners/ClipLoader";
import { useSnackbar } from "notistack";
// import { CircularProgress } from "@material-ui/core";

import './Table.css';

const useStyles = makeStyles({
    table: {
        minWidth: 700,
        width: "auto"
    },
    tableContainer: {
        width: "auto !important",
        minWidth: "700px !important",
        margin: "auto !important",
        maxHeight: "calc(100vh - 260px)",
        overflow: "auto",
        boxShadow: "0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)"
    },
    paper: {
        width: "auto !important",
        // minWidth: "700px !important",
        // margin: "auto !important",
        overflow: "auto"
    },
    name: {
        fontFamily: "OpenSans",
        fontWeight: 600
    },
    divider: {
        borderLeft: "1px solid",
        margin: "3px 7px",
        height: 15
    },
    text: {
        fontFamily: "OpenSans",
        fontSize: "0.75rem",
        color: "#999",
        alignItems: "center"
    },
    textBold: {
        marginLeft: 3,
        fontWeight: 600
    },
});

const BodyTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.common.black,
        border: "1px solid #dde6ed",
        fontFamily: "OpenSansBold",
        padding: "0px 5px !important",
        fontSize: "0.8rem !important"
    },
    body: {
        border: "1px solid #dde6ed",
        padding: "0px 5px !important",
        fontFamily: "OpenSans",
        fontSize: "0.8rem !important"
    },
}))(TableCell);

const BodyTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: "#f5f9fc",
        },
        '&:nth-of-type(even)': {
            backgroundColor: "#fff",
        }
    },
}))(TableRow);



export default function Tables(props) {
    const classes = useStyles();
    const {
        networks,
        contentTypes,
        year,
        week,
        period,
        spec,
        setSpec,
        temp,
        setTemp
    } = React.useContext(ReportContext);
    const [state, setState] = useState(temp["Characteristics"] ? temp["Characteristics"] : []);
    const [selectedMediums, setSelectedMediums] = useState(temp["selectedMediums"] ? temp["selectedMediums"] : []);
    const [validContentTypes, setValidContentTypes] = useState({});
    const { metrics, data, loading, contentTypeMedium } = props;
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        if (contentTypeMedium) {
            let temp = {}
            contentTypeMedium.forEach(el => {
                temp["medium_" + el.mediumId] = el.contentTypeIds.filter(data => data.enable === 1).map(val => val.contentTypeId)
            })
            setValidContentTypes(temp);
        }
    }, [contentTypeMedium])

    useEffect(() => {
        if (data && metrics && state.length === 0) {
            let values = data.map(item => ({ ...item, maxThreshold: { [item.metricId]: 0 }, contentTypes: {} }))
            setState(values);
        }
    }, [data, metrics, state])

    useEffect(() => {
        if (state && metrics) {
            let currentSpec = { ...spec }
            let mediums = state.filter(data => selectedMediums.indexOf(data.medium) > -1);
            let promptSpec = mediums.map(medium => {
                return {
                    medium: medium.medium,
                    maxThreshold: medium.maxThreshold[medium.metricId],
                    contentTypes: medium.contentTypes[medium.metricId] ? medium.contentTypes[medium.metricId] : [],
                    metric: findMetric(medium.metricId) ? findMetric(medium.metricId).metric : null
                }
            })
            currentSpec["mediums"] = promptSpec;
            setSpec(currentSpec);
            let values = { ...temp }
            values["selectedMediums"] = selectedMediums;
            values["Characteristics"] = state;
            setTemp(values)

        }
    }, [state, selectedMediums, metrics])

    const networkDisplayNames = networks.map(el => el.networkDisplayName).toString();
    const handleMaxThresholdChange = (event, index) => {
        let value = parseInt(event.target.value)
        if (!isNaN(value)) {
            let variable = [...state];
            let metricId = variable[index].metricId;
            variable[index].maxThreshold[metricId] = value;
            setState(variable);
        }
    }
    const handleMetricChange = (value, index) => {
        let variable = [...state];
        variable[index].metricId = value.metricId;
        if (variable[index].maxThreshold[value.metricId] === undefined) variable[index].maxThreshold[value.metricId] = 0
        setState(variable);
    }
    const handleSave = (data, index) => {
        let variable = [...state];
        variable[index].contentTypes[variable[index].metricId] = data;
        setState(variable);
        enqueueSnackbar("Thresholds Added Sucessfully", {
            variant: 'success',
            autoHideDuration: 1500
        })
    }
    const findMetric = id => {
        return metrics.filter(metric => metric.metricId == id)[0]
    }
    const handleChange = (event, medium) => {
        let newSelectedMediums = [...selectedMediums];
        if (event.target.checked) {
            newSelectedMediums.push(medium);
        }
        else {
            const index = newSelectedMediums.indexOf(medium);
            if (index > -1) {
                newSelectedMediums.splice(index, 1);
            }
        }
        setSelectedMediums(newSelectedMediums);
    }
    const handleSelectAllMedium = event => {
        if (event.target.checked) {
            let values = state.filter(el => !isDisable(contentTypes, validContentTypes["medium_" + el.mediumId])).map(el => el.medium)
            setSelectedMediums(values)
        }
        else {
            setSelectedMediums([])
        }
    }
    const isDisable = (data, array) => {
        if (data && array && data.length > 0 && array.length > 0)
            return data.filter(el => array.indexOf(el.contentTypeId) !== -1).length === 0;
        return true;
    }
    return (
        <>
            <TableContainer className={classes.tableContainer} style={{ marginTop: "30px !important" }}>
                <div style={{ display: "flex", height: 32, alignItems: "flex-end", padding: "5px 20px" }}>
                    <div className={classes.name}>Characteristics</div>
                    <div className={classes.text} style={{ display: "flex", marginLeft: "auto" }}>
                        <div>Network :<span className={classes.textBold}>{networkDisplayNames}</span></div>
                        <div className={classes.divider} />
                        <div>Year :<span className={classes.textBold}>{year ?.year}</span></div>
                        <div className={classes.divider} />
                        <div>Week {week ?.weekId}:<span className={classes.textBold}>{period}</span></div>
                    </div>
                </div>
            </TableContainer>
            <TableContainer className={classes.tableContainer} style={{ minHeight: 200 }}>

                <Table stickyHeader aria-label="simple table">
                    <TableHead>
                        <BodyTableRow >
                            <BodyTableCell align="left">
                                <Checkbox
                                    color="primary"
                                    checkedIcon={<CheckBoxCheckedIcon width={24} height={24} />}
                                    // icon={<CheckBoxIcon width={20} height={20} />}
                                    onChange={handleSelectAllMedium}
                                    checked={selectedMediums.length === state.filter(el => !isDisable(contentTypes, validContentTypes["medium_" + el.mediumId])).length}
                                />
                                Channel/Medium
                                </BodyTableCell>
                            <BodyTableCell align="center" >Max Threshold</BodyTableCell>
                            <BodyTableCell align="center">Metric</BodyTableCell>
                            <BodyTableCell align="center">Threshold</BodyTableCell>
                        </BodyTableRow>
                    </TableHead>
                    <TableBody>
                        {!loading && metrics.length > 0 && state.map((row, index) => (
                            <BodyTableRow key={index}>
                                <BodyTableCell>
                                    <Checkbox
                                        color="primary"
                                        checkedIcon={<CheckBoxCheckedIcon width={24} height={24} />}
                                        disabled={isDisable(contentTypes, validContentTypes["medium_" + row.mediumId])}
                                        // icon={<CheckBoxIcon width={20} height={20} />}
                                        checked={selectedMediums.indexOf(row.medium) > -1}
                                        onChange={e => handleChange(e, row.medium)}
                                    />
                                    <span style={{ color: isDisable(contentTypes, validContentTypes["medium_" + row.mediumId]) ? "#aaa" : "#333" }}>{row.mediumDisplayName}</span>
                                </BodyTableCell >
                                <BodyTableCell align="center">
                                    <input type="text" value={row.maxThreshold[row.metricId]} disabled={isDisable(contentTypes, validContentTypes["medium_" + row.mediumId])} onChange={(event) => handleMaxThresholdChange(event, index)} />
                                </BodyTableCell>
                                <BodyTableCell align="center"><SingleSelect disabled={isDisable(contentTypes, validContentTypes["medium_" + row.mediumId])} items={metrics} idKey={"metricId"} defaultValue={row.metricId} labelKey={"metricDisplayName"} onChange={value => handleMetricChange(value, index)} /></BodyTableCell>
                                <BodyTableCell align="center">
                                    <OptimizationThreshold
                                        header={["Content Type", "Min", "Max"]}
                                        contentTypes={contentTypes}
                                        contentTypeMedium={contentTypeMedium.filter(el => el.mediumId === row.mediumId)[0]}
                                        maxThreshold={row.maxThreshold[row.metricId]}
                                        metric={findMetric(row.metricId)}
                                        data={row.contentTypes[row.metricId]}
                                        onSave={data => handleSave(data, index)}
                                        disabled={isDisable(contentTypes, validContentTypes["medium_" + row.mediumId])}
                                    />
                                </BodyTableCell>

                            </BodyTableRow>
                        ))}

                    </TableBody>
                </Table>
                {
                    loading && <div style={{ display: "flex", justifyContent: "center", padding: 10, height: 120 }}><ClipLoader color={"#1976d2"} loading={loading} size={100} /></div>
                }
            </TableContainer>
        </>

    );
}
